import Glide from '@glidejs/glide';
import { initializeArticleSlider } from '~/components/shared/articles-slider';

// set up review slider
const reviewsSliderSelector = '.directory-reviews__container.glide';
const reviewsSliderEl = document.querySelector(reviewsSliderSelector);
if (reviewsSliderEl) {
  const reviewsSlider = new Glide(reviewsSliderSelector, {
    perView: 1.8,
    gap: 20,
    peek: {
      before: 0,
      after: 40,
    },
    breakpoints: {
      650: {
        perView: 1.2,
        gap: 10,
        peek: {
          before: 0,
          after: 32,
        },
      },
    },
  });
  reviewsSlider.mount();
}

// set up article slider

const articleSliderSelector = '.directory-featured-articles.glide';

if (articleSliderSelector) {
  const articleSliderOptions = {
    type: 'carousel',
    startAt: 0,
    perView: 5,
    slideWidth: 248,
    gap: 10,
    peek: {
      before: 0,
      after: 12,
    },
    breakpoints: {
      1024: {
        perView: 3,
        peek: {
          before: 0,
          after: 40,
        },
      },
      650: {
        perView: 2,
        peek: {
          before: 0,
          after: 32,
        },
      },
      450: {
        perView: 1,
        peek: {
          before: 0,
          after: 32,
        },
      },
    },
  };

  initializeArticleSlider(articleSliderSelector, articleSliderOptions);
}
